(() => {
  if (window.blcOverlayHistoryReady) return;
  window.blcOverlayHistoryReady = true;

  const key = 'blcOverlayHistory';
  const previous = history.state && typeof history.state === 'object' ? history.state[key] : null;
  const page = previous?.path === location.pathname ? previous.page : Date.now().toString(36) + Math.random().toString(36).slice(2);
  let entries = [];
  let retiring = null;
  let restoring = previous?.path === location.pathname && Array.isArray(previous.entries) ? previous.entries.slice() : [];
  const closing = new Set();
  const cooldown = new Map();
  let restoreAttempt = 0;
  let restoreTimer = null;
  let syncing = false;

  const visible = element => !!element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const clickVisible = selector => {
    const element = [...document.querySelectorAll(selector)].find(visible);
    if (!element) return false;
    element.click();
    return true;
  };
  const overlays = {
    cart: {
      open: () => document.getElementById('t4s-mini_cart')?.getAttribute('aria-hidden') === 'false',
      close: () => {
        const cart = document.getElementById('t4s-mini_cart');
        cart?.querySelector('[data-drawer-close]')?.click();
        setTimeout(() => {
          if (cart?.isConnected && cart.getAttribute('aria-hidden') === 'true' && document.body.classList.contains('is--opend-drawer') && !document.querySelector('.t4s-drawer[aria-hidden="false"]')) {
            cart.dispatchEvent(new Event('transitionend'));
          }
        }, 650);
      },
      ready: () => !document.body.classList.contains('is--opend-drawer'),
      show: () => clickVisible('[data-drawer-options*="t4s-mini_cart"]')
    },
    engraving: {
      open: () => document.body.classList.contains('pplr_fixed') && visible(document.querySelector('.pplr-popup')),
      close: () => document.querySelector('.pplr-popup .p_h_d .pplr_close')?.click(),
      show: () => clickVisible('.t4s-section-main-product .pplr-c-button')
    },
    cartBundle: {
      open: () => !!document.querySelector('dialog.blc-cart-bundle-dialog[open]'),
      close: () => document.querySelector('dialog.blc-cart-bundle-dialog[open]')?.close(),
      show: () => clickVisible('[data-blc-cart-offer] button')
    },
    bundleEngraving: {
      open: () => !!document.querySelector('dialog[data-blc-bundle-dialog][open]'),
      close: () => document.querySelector('dialog[data-blc-bundle-dialog][open]')?.close(),
      show: () => clickVisible('[data-blc-last-editor]')
    },
    bundlePicker: {
      open: () => !!document.querySelector('dialog.blc-product-picker[open]'),
      close: () => document.querySelector('dialog.blc-product-picker[open]')?.close(),
      show: () => clickVisible('[data-blc-last-picker]')
    },
    guide: {
      open: () => !!document.querySelector('dialog.blc-guide-dialog[open]'),
      close: () => document.querySelector('dialog.blc-guide-dialog[open]')?.close(),
      show: () => clickVisible('dialog[data-blc-bundle-dialog][open] [data-blc-bundle-guide], .pplr-popup .blc-guide-trigger')
    }
  };

  const marker = state => {
    const value = state && typeof state === 'object' ? state[key] : null;
    return value?.page === page && value.path === location.pathname && Array.isArray(value.entries) ? value : null;
  };
  const ownedTop = () => marker(history.state)?.entries.at(-1)?.id === entries.at(-1)?.id;
  const push = kind => {
    const entry = {id: Date.now().toString(36) + Math.random().toString(36).slice(2), kind};
    const next = [...entries, entry];
    const state = history.state && typeof history.state === 'object' ? {...history.state} : {};
    state[key] = {page, path: location.pathname, entries: next};
    try {
      history.pushState(state, '', location.href);
      entries = next;
    } catch (_) {}
  };

  function sync() {
    if (syncing || retiring) return;
    syncing = true;
    try {
      while (restoring.length) {
        const next = restoring[0];
        const overlay = overlays[next.kind];
        if (!overlay) {
          restoring.shift();
          continue;
        }
        const delay = (cooldown.get(next.kind) || 0) - Date.now();
        if (delay > 0) {
          if (!restoreTimer) restoreTimer = setTimeout(() => { restoreTimer = null; sync(); }, delay);
          return;
        }
        if (overlay.open()) {
          entries.push(next);
          restoring.shift();
          restoreAttempt = 0;
          if (restoreTimer) clearTimeout(restoreTimer);
          restoreTimer = null;
          continue;
        }
        if (overlay.ready && !overlay.ready()) return;
        if (restoreAttempt === 0 && overlay.show()) restoreAttempt = 1;
        return;
      }
      for (const kind of closing) if (!overlays[kind].open()) closing.delete(kind);
      const top = entries.at(-1);
      if (top && !overlays[top.kind].open()) {
        if (ownedTop()) {
          retiring = top.id;
          history.back();
          return;
        }
        entries.pop();
      }
      for (const [kind, overlay] of Object.entries(overlays)) {
        if (overlay.open() && !closing.has(kind) && !entries.some(entry => entry.kind === kind)) push(kind);
      }
    } finally {
      syncing = false;
    }
  }

  window.addEventListener('popstate', event => {
    const desired = marker(event.state)?.entries || [];
    const closedByUser = retiring;
    retiring = null;
    if (restoreTimer) clearTimeout(restoreTimer);
    restoreTimer = null;
    restoreAttempt = 0;
    let common = 0;
    while (common < entries.length && common < desired.length && entries[common].id === desired[common].id) common++;
    const removed = entries.splice(common);
    for (const entry of removed.reverse()) {
      cooldown.set(entry.kind, Date.now() + (entry.kind === 'cart' ? 600 : entry.kind === 'engraving' ? 450 : 0));
      if (entry.id !== closedByUser && overlays[entry.kind]?.open()) {
        closing.add(entry.kind);
        overlays[entry.kind].close();
      }
    }
    restoring = desired.slice(common);
    sync();
  });

  const watched = new WeakSet();
  const stateObserver = new MutationObserver(sync);
  stateObserver.observe(document.body, {attributes: true, attributeFilter: ['class']});
  const watch = () => {
    document.querySelectorAll('#t4s-mini_cart, .pplr-popup, dialog.blc-guide-dialog, dialog.blc-cart-bundle-dialog, dialog[data-blc-bundle-dialog], dialog.blc-product-picker').forEach(element => {
      if (watched.has(element)) return;
      watched.add(element);
      stateObserver.observe(element, {attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'open']});
    });
  };
  const contentObserver = new MutationObserver(() => { watch(); sync(); });
  contentObserver.observe(document.body, {subtree: true, childList: true});
  watch();
  window.addEventListener('pageshow', sync);
  window.addEventListener('blcOverlayChange', () => { watch(); sync(); });
  window.addEventListener('load', sync, {once: true});
  sync();
})();
